import axiosBase from "axios";

import config from "@/config";
import { router } from "@/router";

import deleteAccessTokenAndUserData from "./deleteAccessTokenAndUserData";

const axios = axiosBase.create({
  baseURL: config.apiBaseUrl,
  withCredentials: true,
  headers: { Accept: "application/json" },
  transformRequest: [
    function addCredentialsToRequest(data, headers) {
      const accessToken = localStorage.getItem("access_token");

      if (accessToken) {
        headers.Authorization = `Bearer ${accessToken}`;
      }
      return data;
    },
    ...axiosBase.defaults.transformRequest,
  ],
});

axios.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      deleteAccessTokenAndUserData();
      router.invalidate();
    }
    return Promise.reject(error);
  },
);

export default axios;
